module.exports = __webpack_public_path__ + "static/media/logout_black_24dp.076e4d3b.svg";